export const slideIndicatorPlacementOptions = {
    inside: 'inside',
    none: 'none',
    outside: 'outside',
};
export const carouselDotModifiers = {
    dark: 'dark',
    light: 'light',
};
export const carouselButtonNavigationTypes = {
    next: 'next',
    previous: 'previous',
};
export const carouselButtonArrowTypes = {
    next: 'arrow-right',
    previous: 'arrow-left',
};
